var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('template-personal',{attrs:{"pathName":_vm.pathName,"hasFinalTaxType":_vm.hasFinalTaxType,"fact":_vm.fact}},[_c('div',{attrs:{"slot":"to-do"},slot:"to-do"},[_c('div',{staticClass:"contents"})])])}
var staticRenderFns = []

export { render, staticRenderFns }